"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchGet = exports.MAX_READ_BATCH_SIZE = void 0;
var tslib_1 = require("tslib");
var client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
var BatchOperation_1 = require("./BatchOperation");
exports.MAX_READ_BATCH_SIZE = 100;
/**
 * Retrieves items from DynamoDB in batches of 100 or fewer via one or more
 * BatchGetItem operations. The items may be from any number of tables.
 *
 * This method will automatically retry any get requests returned by DynamoDB as
 * unprocessed. Exponential backoff on unprocessed items is employed on a
 * per-table basis.
 */
var BatchGet = /** @class */ (function (_super) {
    tslib_1.__extends(BatchGet, _super);
    /**
     * @param client    The AWS SDK client with which to communicate with
     *                  DynamoDB.
     * @param items     A synchronous or asynchronous iterable of tuples
     *                  describing the reads to execute. The first member of the
     *                  tuple should be the name of the table from which to
     *                  read, and the second should be the marshalled key.
     * @param options   Additional options to apply to the operations executed.
     */
    function BatchGet(client, items, _a) {
        var _b = _a === void 0 ? {} : _a, ConsistentRead = _b.ConsistentRead, _c = _b.PerTableOptions, PerTableOptions = _c === void 0 ? {} : _c;
        var _this = _super.call(this, client, items) || this;
        _this.batchSize = exports.MAX_READ_BATCH_SIZE;
        _this.consistentRead = ConsistentRead;
        _this.options = PerTableOptions;
        return _this;
    }
    BatchGet.prototype.doBatchRequest = function () {
        var _a, _b, _c, _d;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var operationInput, batchSize, _e, tableName, item, _f, projection, consistentRead, attributeNames, _g, _h, Responses, _j, UnprocessedKeys, unprocessedTables, _k, _l, table, _m, _o, table, tableData, _p, _q, item;
            var e_1, _r, e_2, _s, e_3, _t;
            return tslib_1.__generator(this, function (_u) {
                switch (_u.label) {
                    case 0:
                        operationInput = { RequestItems: {} };
                        batchSize = 0;
                        while (this.toSend.length > 0) {
                            _e = tslib_1.__read(this.toSend.shift(), 2), tableName = _e[0], item = _e[1];
                            if (((_a = operationInput.RequestItems) === null || _a === void 0 ? void 0 : _a[tableName]) === undefined) {
                                _f = this.state[tableName], projection = _f.projection, consistentRead = _f.consistentRead, attributeNames = _f.attributeNames;
                                // @ts-ignore
                                operationInput.RequestItems[tableName] = {
                                    Keys: [],
                                    ConsistentRead: consistentRead,
                                    ProjectionExpression: projection,
                                    ExpressionAttributeNames: attributeNames,
                                };
                            }
                            (_d = (_c = (_b = operationInput.RequestItems) === null || _b === void 0 ? void 0 : _b[tableName]) === null || _c === void 0 ? void 0 : _c.Keys) === null || _d === void 0 ? void 0 : _d.push(item);
                            if (++batchSize === this.batchSize) {
                                break;
                            }
                        }
                        return [4 /*yield*/, this.client.send(new client_dynamodb_1.BatchGetItemCommand(operationInput))];
                    case 1:
                        _g = _u.sent(), _h = _g.Responses, Responses = _h === void 0 ? {} : _h, _j = _g.UnprocessedKeys, UnprocessedKeys = _j === void 0 ? {} : _j;
                        unprocessedTables = new Set();
                        try {
                            for (_k = tslib_1.__values(Object.keys(UnprocessedKeys)), _l = _k.next(); !_l.done; _l = _k.next()) {
                                table = _l.value;
                                unprocessedTables.add(table);
                                this.handleThrottled(table, UnprocessedKeys[table].Keys || []);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_l && !_l.done && (_r = _k.return)) _r.call(_k);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.movePendingToThrottled(unprocessedTables);
                        try {
                            for (_m = tslib_1.__values(Object.keys(Responses)), _o = _m.next(); !_o.done; _o = _m.next()) {
                                table = _o.value;
                                tableData = this.state[table];
                                tableData.backoffFactor = Math.max(0, tableData.backoffFactor - 1);
                                try {
                                    for (_p = (e_3 = void 0, tslib_1.__values(Responses[table])), _q = _p.next(); !_q.done; _q = _p.next()) {
                                        item = _q.value;
                                        this.pending.push([table, item]);
                                    }
                                }
                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                finally {
                                    try {
                                        if (_q && !_q.done && (_t = _p.return)) _t.call(_p);
                                    }
                                    finally { if (e_3) throw e_3.error; }
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_o && !_o.done && (_s = _m.return)) _s.call(_m);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BatchGet.prototype.getInitialTableState = function (tableName) {
        var _a = this.options[tableName] || {}, ExpressionAttributeNames = _a.ExpressionAttributeNames, ProjectionExpression = _a.ProjectionExpression, _b = _a.ConsistentRead, ConsistentRead = _b === void 0 ? this.consistentRead : _b;
        return tslib_1.__assign(tslib_1.__assign({}, _super.prototype.getInitialTableState.call(this, tableName)), { attributeNames: ExpressionAttributeNames, projection: ProjectionExpression, consistentRead: ConsistentRead });
    };
    return BatchGet;
}(BatchOperation_1.BatchOperation));
exports.BatchGet = BatchGet;
